import * as React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { AxiosResponse } from "axios";

import Loader from "src/common/components/Loader";
import ConfirmButton from "src/common/components/ui/ConfirmButton";
import {
  WorkflowConfigForm,
  WorkflowConfigFormInput,
  WorkflowConfigFormError,
  WorkflowConfigFormData,
} from "src/domain/core/workflow/components/update/forms/ConfigForm";

const BottomGroup = styled("div")(() => ({
  width: "100%",
  display: "flex",
  marginTop: "30px",
  justifyContent: "center",
}));

interface UpdateWorkflowProps {
  apiData: WorkflowConfigFormData;
  error: WorkflowConfigFormError;
  setError: React.Dispatch<React.SetStateAction<WorkflowConfigFormError>>;
  values: WorkflowConfigFormInput;
  setValues: React.Dispatch<React.SetStateAction<WorkflowConfigFormInput>>;
  validate: () => boolean;
  onSubmit: (values: WorkflowConfigFormInput) => Promise<AxiosResponse>;
  cb: () => void;
}

export const UpdateWorkflowForm: React.FC<UpdateWorkflowProps> = ({
  apiData,
  error,
  setError,
  values,
  setValues,
  validate,
  onSubmit,
  cb,
}) => {
  const [showLoader, setShowLoader] = React.useState(false);
  const [cancelBtnDisabled, setCancelBtnDisabled] = React.useState(false);
  const [head_node_instance_type] = React.useState(values.head_node_instance_type);

  const submit = async () => {
    if (validate()) {
      setShowLoader(true);
      setCancelBtnDisabled(true);

      const resp = await onSubmit(values);
      if (resp && !resp?.ok) {
        setShowLoader(false);
        setCancelBtnDisabled(false);
      }
    }
  };
  const submitCallback = React.useCallback(submit, [onSubmit, validate, values]);

  const showModalFunc = () => {
    return values.head_node_instance_type != head_node_instance_type;
  };

  return (
    <>
      <div className="centered-page">
        <Box
          component="form"
          autoComplete="off"
          sx={{
            flexWrap: "wrap",
            width: "100%",
            "& .MuiTextField-root": {
              marginLeft: 5,
              marginRight: 5,
              marginBottom: 5,
            },
          }}
        >
          <WorkflowConfigForm
            workflowData={apiData}
            values={values}
            setValues={setValues}
            error={error}
            setError={setError}
          />
          <BottomGroup>
            <Button
              disabled={cancelBtnDisabled}
              size="small"
              variant="contained"
              onClick={cb}
              sx={{ width: "90px", margin: "5px" }}
            >
              Cancel
            </Button>

            <ConfirmButton
              data-testid="workflow-update-button"
              showModalFunc={showModalFunc}
              confirmText="You are updating head node size. This will cause a brief outage while the instance is moved to new hardware. Running processes will be terminated. Do you want to proceed?"
              confirmButtonText="Proceed"
              loading={showLoader}
              loadingIndicator="Updating..."
              type="submit"
              size="small"
              variant="contained"
              sx={{ width: "90px", margin: "5px" }}
              onSubmit={submitCallback}
            >
              Update
            </ConfirmButton>
            <div className="small-loader">{showLoader && <Loader />}</div>
          </BottomGroup>
        </Box>
      </div>
    </>
  );
};
